import { render, staticRenderFns } from "./Ordendesop.vue?vue&type=template&id=7a6f39e0&scoped=true"
import script from "./Ordendesop.vue?vue&type=script&lang=js"
export * from "./Ordendesop.vue?vue&type=script&lang=js"
import style0 from "./Ordendesop.vue?vue&type=style&index=0&id=7a6f39e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f39e0",
  null
  
)

export default component.exports